
<template>
    <div v-if="uiTranslationsLoaded || !loggedIn">
        <slot />
    </div>
</template>


<script>
    import Vue from 'vue'
    import { LoadLocales, t } from '@/services/i18n'
    import { store } from '@/store'
    export default {
        name: "Localizer",
        data() {
            return {
                uiTranslationsLoaded: false,
                loggedIn: false

            }
        },
        computed: {
            loggedInUser() {5
                return store.state.account.user
            }
        },
        mounted() {
          if(store.state.account.user && store.state.account.user.userId && store.state.account.user.userId > 0)
          {
              this.loggedIn = true
              this.set()
          }
        },
        methods: {
          set() {
              LoadLocales().then(() => {
                  Vue.prototype.$t = t
                  this.uiTranslationsLoaded = true
              }).catch(err => console.error(err))
          }
        },
        watch: {
            loggedInUser(newUser) {
                if(newUser && newUser.userId && newUser.userId > 0) {
                        this.loggedIn = true
                        this.set()
                }
            }
        }
    }
</script>

<style scoped>

</style>